import Player from './player';
export default class Car extends Phaser.GameObjects.Image {
    private _tintImage: Phaser.GameObjects.Image;
    private _healthPackTween: Phaser.Tweens.Tween;
    private _parent: Player;

    public body: Phaser.Physics.Arcade.Body;
    public tag: string;
    public key: string;

    constructor(scene: Phaser.Scene, x: number, y: number, parent: Player, key: string, frame?: string) {
        super(scene, x, y, key, frame);
        this._parent = parent;
        this.tag = frame;
        this.key = key;

        this.scene.add.existing(this);

        this._createTintImage();
        this.setDepth(3);
        this._tintImage.setDepth(4);

        this._parent.add(this);
        this._parent.add(this._tintImage);

        this._initPhysics();
        this.stop();
    }

    private _createTintImage() {
        this._tintImage = this.scene.add.image(this.x, this.y, this.key, this.tag);
        this.setCarTexture();
        this._tintImage.setAlpha(0.5);
        this._tintImage.setActive(false);
        this._tintImage.setVisible(false);
        this.scene.add.existing(this._tintImage);
        this._healthPackTween = this.scene.tweens.addCounter({
            from: 255,
            to: 0,
            duration: 250,
            callbackScope: this,
            repeat: 2,
            onUpdate: function (tween) {
                var value = Math.floor(tween.getValue());
                this._tintImage.setTintFill(Phaser.Display.Color.GetColor(value, value, value));
            },
            onComplete: function () {
                this._tintImage.setVisible(false);
                this.clearTint();
                this.setCarTexture();
            },
            paused: true
        });
        // this._healthPackTween.stop();
    }

    private _initPhysics(): void {
        this.scene.physics.world.enable(this);
        this.body.setImmovable(true);
        this.body.moves = false;
        this.body.setAllowGravity(false);
        this.body.setAllowDrag(false);
        // let offset = window.constants.DATA.colliderOffset[this.tag];
        // this.body.setSize(this.width * offset.width, this.height * offset.height);
        // this.body.setOffset(this.width * offset.x, this.height * offset.y);
        // this.setOrigin(offset.cx, offset.cy);
        // this._tintImage.setOrigin(offset.cx, offset.cy);

        this.body.moves = false;
    }

    public healthPackTween() {
        this._tintImage.setVisible(true);
        this._healthPackTween.play();
    }

    public hit(key, value) {
        this._parent.hit(key, value);
    }

    public setBrokenTexture() {
        // this.setTint(0x990000);
        // if (this.tag == "player_day") {
        //     this.setTexture("assets", 'broken_player');
        // }
        // else {
        //     this.setTexture("assets", 'broken_' + this.tag);
        // }

        switch (window.constants["CAR_CHOOSEN"]) {
            case 0:
                this.setTexture("assets", "broken_player");
                break;
            case 1:
                this.setTexture("car_01_dead");
                break;
            case 2:
                this.setTexture("car_02_dead");
                break;
            case 3:
                this.setTexture("car_03_dead");
                break;
            case 4:
                this.setTexture("car_04_dead");
                break;
            case 5:
                this.setTexture("car_05_dead");
                break;
            case 6:
                this.setTexture("car_06_dead");
                break;
        }
    }

    public reset() {
        this.clearTint();
        // if (window.constants["MAP"] != 0) {
        //     this.setTexture("assets", "player_day");
        // } else {
        this.setTexture(this.key, this.tag);
        // }
        this.setCarTexture();
    }

    private setCarTexture() {
        switch (window.constants["CAR_CHOOSEN"]) {
            case 0:
                this.setTexture("assets", "player_day");
                break;
            case 1:
                this.setTexture("car_01");
                break;
            case 2:
                this.setTexture("car_02");
                break;
            case 3:
                this.setTexture("car_03");
                break;
            case 4:
                this.setTexture("car_04");
                break;
            case 5:
                this.setTexture("car_05");
                break;
            case 6:
                this.setTexture("car_06");
                break;
        }
        // if (window.constants["CAR_CHOOSEN"] == 0) {
        //     this.setTint(0xbb0000);
        // } else if (window.constants["CAR_CHOOSEN"] == 1) {
        //     this.setTint(0x0000bb);
        // } else if (window.constants["CAR_CHOOSEN"] == 2) {
        //     this.setTint(0x00bb00);
        // }
    }

    private _startPhysics() {
        this.body.setEnable(true);
        this.scene.physics.world.enable(this);
    }

    private _stopPhysics() {
        this.body.stop();
        this.body.setEnable(false);
        this.scene.physics.world.disable(this);
    }

    public start() {
        this.setActive(true);
        this.setVisible(true);
        this._startPhysics();
    }

    public stop() {
        this.setActive(false);
        this._stopPhysics();
    }

    update(time, dt) {

    }
}